import { Context, useMemo, createElement, ReactNode, FunctionComponentElement, ProviderProps } from 'react';

export const useProvider = <C extends Context<V>, V>(
  { Provider }: C,
  value: V,
  children?: ReactNode,
): FunctionComponentElement<ProviderProps<V>> =>
  useMemo(() => createElement(Provider, { value }, children), [children, Provider, value]);
